import { useAuthStore } from '@/auth/authStore';
import { Perm } from '@/auth/permissions';
import { useModuleStore } from '@/core/modules/moduleStore';
import { Modules } from '@/core/modules/moduleKeys';
import { useMyAccess } from './api';
import { useFacilityStore } from './facilityStore';

/**
 * The facility actions the person holds where they are working (docs §301e), for the menu. Asked only where Health is on and the person may use it,
 * and again whenever they choose another facility. Empty until a facility is chosen, so the menu then offers only what needs no role.
 */
export function useHealthNavActions(): ReadonlySet<string> {
  const on = useModuleStore((s) => s.enabled[Modules.Health] === true);
  const uses = useAuthStore((s) => s.hasPermission(Perm.Health.Use));
  const facilityId = useFacilityStore((s) => s.facilityId);
  const { data } = useMyAccess(facilityId, on && uses);
  return new Set(data?.actions ?? []);
}
